import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbDatepickerModule, NgbDropdownModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from "ng-apexcharts";
import { AddproductComponent } from './addproduct.component';
import { ViewProductComponent } from './viewproduct.component';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimeAdapter, OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DirectivesModule } from 'src/app/views/layout/directives/directives.module';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { AddProductPopupComponent } from './addproductpopup.component';
import { ArchwizardModule } from 'angular-archwizard';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MomentDateTimeAdapter } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { ProductService } from 'src/app/services/product.service';
import { ProductinfoComponent } from './productinfo.component';
import { HttpClientModule } from '@angular/common/http';
import { DriverService } from 'src/app/services/driver.service';
import { MatTabsModule } from '@angular/material/tabs';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ProductUpdatePopupComponent } from './productupdatepopup/productupdatepopup.component';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import { MatTreeModule } from '@angular/material/tree';
import { ProducttimelineComponent } from './producttitimeline/producttimeline.component';
import { LightboxModule } from 'ngx-lightbox';
import { ProductimgpopupComponent } from './productupdatepopup/productimgpopup/productimgpopup.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

export const MY_FORMATS = {
  parseInput: 'DD/MM/YYYY',
  fullPickerInput: 'DD/MM/YYYY hh:mm a',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY'
}

const routes: Routes = [
  {
    path: ':id',
    component: ViewProductComponent
  },
  {
    path: '',
    component: ViewProductComponent
  },
  {
    path: ':id/:actionInfo',
    component: ProductinfoComponent
  },
  {
    path: ':id/:year/:actionInfo',
    component: ProductinfoComponent
  },
  {
    path: ':id/:actionInfo/:product/:classification/:categoryType',
    component: AddproductComponent
  }
]

@NgModule({
  declarations: [ViewProductComponent, AddproductComponent, AddProductPopupComponent,ProductimgpopupComponent, ProductinfoComponent, ProductUpdatePopupComponent, ProducttimelineComponent],
  providers: [
    ProductService,
    DriverService,
    ManufacturerService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    {provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE]},
    {provide: OWL_DATE_TIME_FORMATS, useValue: MY_FORMATS},
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'ist'},
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } }],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    FeahterIconModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    TranslateModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    ArchwizardModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule,
    HttpClientModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatTooltipModule,
    MatButtonModule,
    MatRadioModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    DirectivesModule,
    MatSelectModule,
    MatSelectFilterModule,
    MatTabsModule,
    MatTreeModule,
    LightboxModule,
    NgbModule,
    MatCheckboxModule,
  ],
  exports: [ViewProductComponent,ProducttimelineComponent]
})
export class ProductModule { }
